import { QueryParamsType } from "src/types/query-params";
import qs from "qs";
import useRequest from "src/hooks/useRequest";
import { IPermission, IRole } from "src/types/acl";

export const useRole = (query: Record<string, QueryParamsType>) => {
  const url = `/roles?${qs.stringify(query)}`;
  const { data, mutate, isLoading, error, ...rest } = useRequest(url, url);
  return {
    roles: (data as Array<IRole>) || [],
    mutate,
    isLoading,
    error,
    ...rest,
  };
};
